import Request from 'utils/request';
import config from 'config/Config';

export default class {
  // 获取移动端活动广告弹窗
  static getActiveAdList(params) {
    return Request({
      url: `content/recommand/popup/show`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true,
      data: params
    });
  }
  //保存弹窗显示记录
  static savePopupRecord(params) {
    return Request({
      url: `content/recommand/popup/record/save`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true,
      data: params
    });
  }

  // 通过产品id查商品详情
  static getProductDetail(itemCode) {
    return Request({
      // url: `item/biz/ext/get/${id}`,
      url: `item/biz/ext/get/code/${itemCode}`,
      // url: `item/biz/ext/get/1313294857944954924`,
      host: config.HOST_MALL,
      ignoreErr: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/ActiveAdPopup/indexServ.js